import IAppSettings from "../../../../iApp.settings";

export class GTMService implements angular.IServiceProvider {

    public constructor() {
        this.$get.$inject = ['appSettings', '$document',  '$window'];
    }
    public $get(appSettings: IAppSettings, $document: ng.IDocumentService,  $window: ng.IWindowService) {
        //only has gtmSource for dev not prod environments
        const gtmSource = appSettings.gtmSource || '';
        const gtmScript: string = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" + 
            "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," + 
            "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" + 
            "'https://www.googletagmanager.com/gtm.js?id='+i+dl+'"+ gtmSource + 
            "';f.parentNode.insertBefore(j,f);" +
            "})(window,document,'script','dataLayer','GTM-5PZ55V6');";

         var script = $window.document.createElement('script');
         script.innerHTML = gtmScript;
         $document.find('head').append(script);

         return this;
    }
}
